import { memo, Component } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import TabBar from '@alltrails/shared/denali/components/TabBar';
import * as styles from './styles/styles.module.scss';
import TrailDetailItem from '../TrailDetailItem';
import TrailEditHistory from '../TrailEditHistory';
import WaypointsWrapper from '../../Waypoints/WaypointsWrapper';
import { XLATE_NONE } from '../../../Constants';
import { logTrailDetailsTabClicked } from '../../../utils/trail_analytics_helpers';

class TrailOverview extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activeTabKey: props.tabs.length ? props.tabs[0].key : '',
      messagingChannel: null
    };
  }

  componentDidMount() {
    // legacy method for communicating between trail details & search_app
    // TODO: replace messaging channel in explore
    if (window.parent && window.parent.messagingTunnel) {
      this.setState({ messagingChannel: window.parent.messagingTunnel('explore_messagingChannel') });
    }
  }

  handleTabChange = tabKey => {
    if (tabKey === this.state.activeTabKey) {
      return;
    }

    logTrailDetailsTabClicked(this.props.trailId, tabKey);
    this.setState({ activeTabKey: tabKey });
  };

  getTabs() {
    const { context, tabs } = this.props;
    return tabs
      .filter(tab => !(!context.adminUser && tab.key === 'waypoints' && tab.value.waypoints?.length === 0))
      .map(tab => {
        return {
          id: tab.key,
          label: tab.label,
          testId: `trail-overview-tab-${tab.key}`
        };
      });
  }

  renderOverviewContent() {
    return this.props.tabs.map(tab => {
      const visible = this.state.activeTabKey === tab.key;

      if (tab.key === 'waypoints') {
        return (
          <div className={classNames(styles.waypointsWrapper, visible ? '' : 'hidden')} key={tab.key}>
            <WaypointsWrapper
              canEdit={this.props.adminOrPendingOwner}
              waypoints={tab.value.waypoints}
              mapId={tab.value.id}
              trailId={this.props.trailId}
              messagingChannel={this.state.messagingChannel}
              isAdmin={this.props.context.adminUser}
            />
          </div>
        );
      }

      if (tab.key === 'edit_history') {
        return (
          <div className={visible ? '' : 'hidden'} key={tab.key}>
            <TrailEditHistory trailId={this.props.trailId} visible={visible} />
          </div>
        );
      }

      return (
        <TrailDetailItem
          key={tab.key}
          trailId={this.props.trailId}
          activeTab={this.state.activeTabKey}
          editItem={tab}
          adminOrPendingOwner={this.props.adminOrPendingOwner}
          adminUser={this.props.context.adminUser}
          loggedInUser={this.props.loggedInUser}
          visible={visible}
          descriptionInitiallyExpanded={this.props.descriptionInitiallyExpanded}
        />
      );
    });
  }

  render() {
    const tabs = this.getTabs();
    return (
      <div className={XLATE_NONE}>
        {tabs.length ? (
          <>
            <TabBar
              activeTab={this.state.activeTabKey}
              className={styles.tabBar}
              onChange={this.handleTabChange}
              tabs={tabs}
              testId="trail-overview-tab-bar"
            />
            {this.renderOverviewContent()}
          </>
        ) : null}
      </div>
    );
  }
}

TrailOverview.propTypes = {
  adminOrPendingOwner: PropTypes.bool,
  context: PropTypes.shape({
    adminUser: PropTypes.bool,
    mobileBrowser: PropTypes.bool,
    proUser: PropTypes.bool,
    tabletBrowser: PropTypes.bool,
    displayMetric: PropTypes.bool,
    locale: PropTypes.string
  }).isRequired,
  loggedInUser: PropTypes.bool,
  trailId: PropTypes.number.isRequired,
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      key: PropTypes.string,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
      sourceText: PropTypes.string,
      maxLength: PropTypes.number
    })
  ).isRequired,
  adminUser: PropTypes.bool,
  descriptionInitiallyExpanded: PropTypes.bool
};

TrailOverview.defaultProps = {
  adminUser: null
};

export default memo(TrailOverview);
